import { buildScopedI18n } from '../../utils/buildScopedI18n';
import wfEsCL from './locales/es-CL.json';
import wfEnUS from './locales/en-US.json';
import wfPtBR from './locales/pt-BR.json';

export const workflowI18n = buildScopedI18n({
  esCL: wfEsCL,
  enUS: wfEnUS,
  ptBR: wfPtBR,
});
